import React, { FC, useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { RootState } from "../../ducks";
import _ from "lodash";
import {
  Enum_Location_Status,
  Location,
} from "../../queries/auto-generated/schemas";
import { MapComponent } from "./map-component";
import { MarkerCard } from "./marker-card";

export const MapAllLocations: FC = () => {
  const center = useSelector((state: RootState) => state.location.mapCenter);
  const zoom = useSelector((state: RootState) => state.location.mapZoom);
  const [activeLocations, setActiveLocations] = useState<Location[]>();

  const {
    data: { locations },
    loading,
    error,
  } = useSelector((state: RootState) => state.location);

  useEffect(() => {
    if (!loading && !error) {
      const active = _.filter(locations, (location) => {
        const { coordinates } = location;
        const lat = coordinates?.latitude;
        const lng = coordinates?.longitude;
        return (
          lat !== undefined &&
          lng !== undefined &&
          location.status === Enum_Location_Status.Active
        );
      });
      setActiveLocations(active);
    }
  }, [loading, error, locations]);

  return (
    <div style={{ height: "100%", width: "100%" }}>
      <MapComponent center={center} zoom={zoom}>
        {_.map(activeLocations, (location, index) => {
          const { coordinates } = location;
          const lat = coordinates?.latitude;
          const lng = coordinates?.longitude;
          return lat && lng ? (
            <MarkerCard key={index} lat={lat} lng={lng} location={location} />
          ) : (
            ""
          );
        })}
      </MapComponent>
    </div>
  );
};
